import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom'; // React Router를 사용한다고 가정

const MypageMenu = () => {
  return (
    <MenuContainer>
      <CategoryTitle>마이페이지</CategoryTitle>
      <MenuItems>
        <MenuItem>
          <StyledLink to="/mypage/edit">정보 수정</StyledLink>
        </MenuItem>
        <MenuItem>
          <StyledLink to="/mypage">내 정보</StyledLink>
        </MenuItem>
        <MenuItem>
          <StyledLink to="/member/logout/mypage">로그아웃</StyledLink>
        </MenuItem>
      </MenuItems>
    </MenuContainer>
  );
};

// Styled components
const MenuContainer = styled.div`
  margin-top: 120px;
  width: 250px;

  @media (max-width: 480px) {
    margin-top: 0px;
    margin-left: 16px;
    margin-right: 16px;
  }
`;

const CategoryTitle = styled.div`
  font-size: 14px;
  color: #aaa;
  margin-bottom: 10px;
  @media (max-width: 480px) {
    /* margin-left: 16px;
    margin-right: 16px; */
  }
`;

const MenuItems = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;

  @media (max-width: 480px) {
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 10px;
    /* margin-left: 16px;
    margin-right: 16px; */
  }
`;

const MenuItem = styled.li`
  margin-bottom: 15px;
  font-size: 16px;

  @media (max-width: 480px) {
    margin-bottom: 0;
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: #333;

  &:hover {
    color: #2ac49e;
  }

  @media (max-width: 480px) {
    margin-bottom: 0;
    font-size: 14px;
  }
`;

export default MypageMenu;
